/*
 * Dollarlabs B2B — quick view price shim. TEMPORARY.
 *
 * The Product Price app block paints itself from JavaScript that sweeps the page
 * for block instances exactly once, on load. Dawn's quick view injects a second
 * copy of the block long after that sweep, so the modal is left showing the raw
 * Liquid price: the wrong variant, and no B2B discount. Quick view also renames
 * the section id inside the modal, which breaks the block's own per-variant
 * refetch even once it is running.
 *
 * This file restarts the block for the modal's instance and repairs that refetch.
 * It does nothing when the modal's price has already been painted, so it falls
 * dormant by itself once the app ships its own fix — at which point delete this
 * file and its <script> tag in layout/theme.liquid.
 *
 * Background: artifacts/dmt-quick-view-price.html
 */
(function () {
  'use strict';

  if (window.__dlQuickViewPriceShim) return;
  window.__dlQuickViewPriceShim = true;

  var CONFIG_SEL = 'script.dollarlabs-pp-config';
  var CONFIG_CLASS = 'dollarlabs-pp-config';
  var PARKED_CLASS = 'dollarlabs-pp-config--parked';
  var BOX_SEL = '.dollarlabs_pricelist--product_price';
  var BLOCK_SEL = 'script[src*="product-price-v2"]';

  /* ------------------------------------------------------------------ *
   * 1. Send the block's per-variant section refetch somewhere real.
   *
   * Switching variants inside the modal makes the block ask for
   *   <current path>?variant=<id>&section_id=quickadd-<section>
   * which is wrong twice over: quick view invented that section id, and on a
   * collection or home page the current path is not the product. Rewrite the
   * request to the product URL and the real section, then re-apply quick view's
   * own id renaming to the reply so the block recognises its container.
   * ------------------------------------------------------------------ */

  var nativeFetch = window.fetch.bind(window);

  window.fetch = function (input, init) {
    if (typeof input !== 'string') return nativeFetch(input, init);

    var match = /[?&]section_id=quickadd-([^&]+)/.exec(input);
    if (!match) return nativeFetch(input, init);

    var section = decodeURIComponent(match[1]);
    var info = document.querySelector('product-info[data-original-section="' + section + '"]');
    if (!info || !info.dataset.url) return nativeFetch(input, init);

    var asked = new URL(input, window.location.origin);
    var real = new URL(info.dataset.url, window.location.origin);
    real.search = asked.search;
    real.searchParams.set('section_id', section);

    return nativeFetch(real.toString(), init).then(function (res) {
      if (!res.ok) return res;
      return res.text().then(function (html) {
        return new Response(html.split(section).join('quickadd-' + section), {
          status: res.status,
          statusText: res.statusText
        });
      });
    });
  };

  /* ------------------------------------------------------------------ *
   * 2. Restart the block so it discovers the modal's instance.
   * ------------------------------------------------------------------ */

  // The block's paint step always writes an inline display on these spans, even
  // when it decides there is no discount. Untouched spans are still exactly what
  // Liquid rendered, which is how we tell "never ran" from "ran, nothing to do".
  function painted(box) {
    var regular = box.querySelector('.dollarlabs_pricelist--regular_price');
    return !regular || !!regular.style.display;
  }

  var restarting = false;

  function restart(modal) {
    if (restarting) return;

    var keep = Array.prototype.slice.call(modal.querySelectorAll(CONFIG_SEL));
    if (!keep.length) return;

    var block = modal.querySelector(BLOCK_SEL) || document.querySelector(BLOCK_SEL);
    if (!block) return;

    // Park every config the block has already consumed, so the restart only sets
    // up the modal's instance instead of re-binding the whole page.
    var parked = [];
    Array.prototype.forEach.call(document.querySelectorAll(CONFIG_SEL), function (tag) {
      if (keep.indexOf(tag) !== -1) return;
      tag.className = PARKED_CLASS;
      parked.push(tag);
    });

    function done() {
      window.__dlProductPriceInit = true;
      parked.forEach(function (tag) { tag.className = CONFIG_CLASS; });
      restarting = false;
    }

    restarting = true;
    // The block's own once-per-page guard. Whichever copy of the bundle runs
    // first claims it again, so the sweep still happens exactly once.
    window.__dlProductPriceInit = false;

    var script = document.createElement('script');
    script.src = block.src;
    script.onload = script.onerror = function () {
      script.remove();
      done();
    };
    window.setTimeout(function () { if (restarting) done(); }, 5000);
    document.head.appendChild(script);
  }

  var queued = false;

  function scan() {
    if (queued) return;
    queued = true;
    window.requestAnimationFrame(function () {
      queued = false;
      var modals = document.querySelectorAll('quick-add-modal');
      for (var i = 0; i < modals.length; i++) {
        var boxes = modals[i].querySelectorAll(BOX_SEL);
        for (var j = 0; j < boxes.length; j++) {
          if (!painted(boxes[j])) return restart(modals[i]);
        }
      }
    });
  }

  new MutationObserver(scan).observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();
